import Raven from 'raven-js';

const {
  REACT_APP_URL: appUrl,
  REACT_APP_FACEBOOK: facebook,
  REACT_APP_FACEBOOK_ID: facebookPageId,
  REACT_APP_GOOGLE: google,
  REACT_APP_SENTRY: sentry,
  REACT_APP_GOOGLE_ANALYTICS: googleAnalytics,
  REACT_APP_STRIPE_KEY: stripe,
  REACT_APP_ASSET_URL: ASSETS_URL,
  REACT_APP_API_ENDPOINT: ENDPOINT,
  REACT_APP_TRANSPORTATION_JSON_URL: transportationUrl,
  REACT_APP_RESOURCE_URL: RESOURCE_URL,
} = process.env;

const config = {
  ENDPOINT,
  ASSETS_URL,
  RESOURCE_URL,
  facebook,
  facebookPageId,
  google,
  googleAnalytics,
  stripe,
  sentry,
  appUrl,
  mealPlan: 'bb',
  paymentPlan: 'R',
  honeyguideDefaultImage: `${ASSETS_URL}/honeyguide-to-the-mountains.jpg`,
  transportationUrl,

  // These lodges are out of touch and is requested to be blocked by Dakshina
  // So should be done via back-end. But for now, it's a hack.
  blockedLodgeIds: ['b0a2e8c14674', 'b812a94cb10d', 'b1b59e22df76', 'b88f538adddd'],
  honeyguidePhoneNumber: '+977-9801916215',
  honeyguideEmail: 'nectar@honeyguideapps.com',
};

export default config;
export const setUpSentry = () => Raven.config(config.sentry).install();



// WEBPACK FOOTER //
// ./src/config/index.js